import React, { useState } from 'react';
import { useGlobal } from 'reactn';
import moment from 'moment';
import { Button } from 'antd';
import Card from '../../common/components/Card';
import TimesheetListContainer from './TimesheetListContainer';
import Page from '../../common/components/Page';

const TimesheetListCard = () => {
  const [range, setRange] = useGlobal('range');
  const [loading, setLoading] = useState(false);
  const { startDate, endDate } = range;

  const loadFuture = () => {
    const newMomentEndDate = moment(endDate).add(1, 'month').endOf('month');
    setRange({
      startDate,
      endDate: newMomentEndDate,
    });
  };

  return (
    <Page>
      <Card
        floating
        title="Timesheets"
        bodyBackground={null}
        actionComponent={
          <Button loading={loading} onClick={loadFuture}>
            Load Future Weeks
          </Button>
        }
      >
        <TimesheetListContainer
          startDate={startDate.format('YYYYMMDD')}
          endDate={endDate.format('YYYYMMDD')}
          setRange={setRange}
          onLoadingChange={setLoading}
        />
      </Card>
    </Page>
  );
};

export default TimesheetListCard;
